import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import BankCashBook from './BankCashBook';
import AllLedgers from './AllLedgers';
import DayBook from './DayBook';
import TDSTCSReports from './TDSTCSReports';
import GSTReports from './GSTReports';
import Outstanding from './Outstanding';
import ItemInventory from './ItemInventory';
import { useReportContext } from '../ReportContext';

const ReportBody = () => {
  const { id } = useParams();
  const { updateReportData } = useReportContext();
  const previousIdRef = useRef(id);

  // Clear report data when switching between different reports
  useEffect(() => {
    if (previousIdRef.current !== id && previousIdRef.current !== null) {
      // Report ID changed, clear previous report's data
      updateReportData({
        allAccounts: [],
        cashAccounts: [],
        bankAccounts: [],
        loading: false,
      });
    }
    previousIdRef.current = id;
  }, [id, updateReportData]);

  // Map report IDs to their corresponding components
  const reportComponents = {
    1: BankCashBook,
    3: AllLedgers,
    4: DayBook,
    5: TDSTCSReports,
    6: GSTReports,
    7: Outstanding,
    9: ItemInventory,
  };

  // Get the component for the current ID
  const ReportComponent = id ? reportComponents[id] : null;

  if (!id) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="body1">Please select a report from the header</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 3 }}>
      <ReportComponent />
    </Box>
  );
};

export default ReportBody;
